import {StyleteqState} from "../_definitions/styleteq";

export const currentPathSelector = (state: StyleteqState) => state.router.location.pathname;


// WEBPACK FOOTER //
// ./app/client/_helpers/routerSelectors.ts